import { Component, Input, EventEmitter, Output, AfterContentInit } from '@angular/core';
import { FeedbackRateType } from './feedback-rate-types';
import { LegacyTeacherFeedbackService } from '../teacher-feedback-service/legacy-teacher-feedback.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TeacherFeedbackSurveyModalComponent } from '../teacher-feedback-survey-modal/teacher-feedback-survey-modal.component';
import { RatingAndSurveyQuestions } from '../teacher-feedback-service/rating-and-survey-questions';

@Component({
  selector: 'lp2-teacher-feedback-rate',
  templateUrl: './teacher-feedback-rate.component.html',
  styleUrls: ['./teacher-feedback-rate.component.scss'],
})
export class TeacherFeedbackRateComponent implements AfterContentInit {
  FeedbackRateType = FeedbackRateType;

  isLoadingQuestions = false;
  isSaving = false;
  isErrorDisplayed = false;

  surveyQuestions: RatingAndSurveyQuestions;

  @Input() responseId: number;
  @Input() rate: number;
  @Output() setRate = new EventEmitter<number>();

  constructor(private legacyTeacherFeedbackService: LegacyTeacherFeedbackService, private ngbModal: NgbModal) {}

  ngAfterContentInit() {
    if (!this.rate) {
      this.getSurveyQuestions();
    }
  }

  selectRating(rating: FeedbackRateType) {
    if (this.rate || !this.responseId) {
      return;
    }
    const ratingOptions = this.surveyQuestions.ratingQuestion.options;
    const selectedOption = ratingOptions.find(o => FeedbackRateType[o.questionOption.toUpperCase()] === rating);
    selectedOption.selected = true;

    this.saveRating(rating);
    this.setRate.emit(rating);

    if (rating === FeedbackRateType.SAD) {
      this.openSurveyModal();
    } else {
      this.saveSurvey();
    }
  }

  getSurveyQuestions() {
    this.isLoadingQuestions = true;
    this.legacyTeacherFeedbackService.getRatingAndSurveyQuestions().subscribe(
        (response: RatingAndSurveyQuestions) => {
        this.surveyQuestions = response;
        this.isLoadingQuestions = false;
      },
      error => {
        this.displayError();
      },
    );
  }

  displayError() {
    this.isLoadingQuestions = false;
    this.isSaving = false;
    this.isErrorDisplayed = true;
  }

  openSurveyModal() {
    const surveyModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
    };
    const modalReference = this.ngbModal.open(TeacherFeedbackSurveyModalComponent, surveyModalOptions);
    (<TeacherFeedbackSurveyModalComponent>modalReference.componentInstance).responseId = this.responseId;
  }

  saveRating(rating: FeedbackRateType) {
    this.isSaving = true;
    this.legacyTeacherFeedbackService.saveFeedbackRating(this.responseId, rating).subscribe(() => {
      this.isSaving = false;
    });
    this.setRate.emit(rating);
  }

  saveSurvey() {
    this.isSaving = true;
    this.legacyTeacherFeedbackService
      .saveFeedbackSurvey(this.responseId, [this.surveyQuestions.ratingQuestion, this.surveyQuestions.surveyQuestion])
      .subscribe(() => {
        this.isSaving = false;
      });
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-rate/teacher-feedback-rate.component.ts